import { LitElement, css, html } from 'lit'


export class DzRcMetaSelect extends LitElement {
    static get properties() {
        return {
          breakpoints: { type: String }, // имя отображаемого дочернего элемента
          axis: { type: String } // направление для отслеживания изменений "x" или "y"
        }
    }

    constructor() {
        super()
        this.axis = "x"
    }

    connectedCallback() {
        super.connectedCallback();
        (new ResizeObserver(() => {
            if (!this.breakpoints) return
            let n = 0
            let bpoint = this.getBreakpoint()
            this.renderRoot.replaceChildren()
            for (let child of this.children) {
                let child_slot = child.getAttribute("slot")
                if (bpoint.includes(child_slot)) {
                    let slot = document.createElement("slot")
                    slot.setAttribute("name", child_slot)
                    this.renderRoot.appendChild(slot)
                }
                n++
            }  
            this.requestUpdate()
        })).observe(this)
    }

    getBreakpoint() {
        let bbox = this.getBoundingClientRect()
        let dimension = this.axis == "x" ? bbox.width : bbox.height
        let bpoints = this.breakpoints.split(",").map((s) => s.trim().split(":").map((s) => s.trim()))
        for (let n = 0; n < bpoints.length; n++) {
            if (!bpoints[n + 1]) {
                return bpoints[n].slice(1)
            } else {
                if (dimension < bpoints[n + 1][0]) {
                    return bpoints[n].slice(1)
                }
            }
        }
    }
}

window.customElements.define('dz-rc-metaselect', DzRcMetaSelect)